import React from 'react';
import { PollData_Layout_PollLayout_Type } from 'ricos-schema';

import { withRCEHelpers } from '../rce-helpers-context';
import { PollGridOption } from './PollGridOption';
import { PollListOption } from './PollListOption';
import { PollGridOptionWebview, PollListOptionWebview } from './webview';

export * from './types';

export const PollOption = withRCEHelpers(props => {
  const { layout, rce } = props;

  if (rce.isWebView) {
    switch (layout.poll?.type) {
      case PollData_Layout_PollLayout_Type.GRID:
        return <PollGridOptionWebview {...props} />;

      case PollData_Layout_PollLayout_Type.LIST:
      default:
        return <PollListOptionWebview {...props} />;
    }
  }

  switch (layout.poll?.type) {
    case PollData_Layout_PollLayout_Type.GRID:
      return <PollGridOption {...props} />;

    case PollData_Layout_PollLayout_Type.LIST:
    default:
      return <PollListOption {...props} />;
  }
});
